/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
const slideshowSpeed =
  Number(document.querySelector('[data-slideshow-speed]')
    ?.dataset.slideshowSpeed) * 1000
  || 5 * 1000;  // Fallback value if settings / element not found

var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: setInterval(function() {

    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');

    var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');

    var $slides = $('.slideshow__slide');

    var nextSlideIndex = ($slides.index($slide) + 1) % $slides.length;

    $slides
      .eq(nextSlideIndex)
      .addClass('slideshow__slide--active');

    var $buttons = $('.slideshow__button')
      .eq(nextSlideIndex)
      .addClass('slideshow__button--active');

  }, slideshowSpeed)
};

sections.extend('slideshow', slideshowAutoExtension);